<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Sezim Logo"
          class="shrink mr-2 pointer"
          contain
          :src="require('./assets/sezim-logo.png')"
          transition="scale-transition"
          width="150"
          @click="goToMain()"
        />
      </div>

      <v-tabs
          v-if="isLoggedIn"
          background-color="transparent"
          color="white"
          centered
          optional
      >
        <!--        <v-tab :to="localePath('/')">-->
        <!--          {{ $t('header.mainPage') }}-->
        <!--        </v-tab>-->
        <v-tab to="/">
          Новая анкета
        </v-tab>
        <v-tab v-if="isAdmin" to="users">
          Пользователи
        </v-tab>
        <v-tab to="questionnaires">
          Анкеты
        </v-tab>
        <v-tab to="profile">
          Мой Профиль
        </v-tab>
<!--        <v-tab to="login">-->
<!--          Логин-->
<!--        </v-tab>-->
<!--        <v-tab>-->
<!--          Выйти-->
<!--        </v-tab>-->
      </v-tabs>

      <v-spacer></v-spacer>
      <v-btn
          v-if="!isLoggedIn"
          href="/login"
          text
      >
        <span>Логин</span>
      </v-btn>
      <v-btn
          v-else
          text
          @click="logout"
      >
        <span>Выйти</span>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view v-if="isNotFired"></router-view>
      <v-col v-else>
        <h1>
          Вы были уволены и более не имеете доступ к системе. Если это ошибка - обратитесь к администратору
        </h1>
      </v-col>
    </v-main>
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'App',
  data: () => ({
    //
  }),
  computed: {
    ...mapGetters({
      isLoggedIn: 'security/isLoggedIn',
      isAdmin: 'security/isAdmin',
      isNotFired: 'security/isNotFired',
    })
  },
  methods: {
    goToMain() {
      this.$router.push('/')
    },
    async logout() {
      this.$store.dispatch('security/signOut')
      await this.$router.push({ name: 'LoginPage' })
    }
  }
};
</script>

<style>
  .pointer {
    cursor: pointer;
  }
</style>
